export default "Haben Sie eine Einladung?";



// WEBPACK FOOTER //
// ./src/i18n/de/home/steps/1/type/visit/invitation/question.js